<fieldset class="task-details-description-field">
  <legend class="task-details-description-label">
    {{ 'project-tasks.details.description.title' | translate }}
  </legend>
  <proffeo-ui-expandable-content
    [forceExpanded]="descriptionHasUnsavedChanges()"
    [collapsedMaxHeightPx]="200"
  >
    <proffeo-task-details-description
      (descriptionChange)="descriptionChange.emit($event)"
      (unsavedChangesChange)="unsavedChangesChange.emit($event)"
      [task]="task()"
      [minHeight]="'0px'"
      class="task-details-description-editor block h-auto min-h-0 w-full"
    />
  </proffeo-ui-expandable-content>
</fieldset>

<div class="task-details-description-attachments flex items-start flex-col gap-5 w-full">
  @if (activeUploads().length > 0) {
    <proffeo-file-upload-list
      (cancelRequested)="cancelUpload($event)"
      (dismiss)="dismissUpload($event)"
      [uploads]="activeUploads()"
      class="w-full"
    />
  }
  <div class="flex flex-wrap gap-2 w-full items-stretch">
    <div class="flex min-w-0 flex-1 gap-2 md:items-start max-md:items-stretch">
      <div
        [class.attachments-mobile-subtasks-grid]="!!task().subtasksCount"
        [class.max-md:self-center]="!task().subtasksCount"
        class="flex-shrink-0"
      >
        <proffeo-file-drop
          (filesAdded)="descriptionFilesAdded.emit($event)"
          mode="thumbnail"
          class="flex-shrink-0 max-md:row-start-2"
        />
      </div>
      @if (descriptionFiles().length > 0) {
        <proffeo-file-mini-list
          (delete)="fileDelete.emit($event)"
          (avatarSet)="avatarSet.emit($event)"
          [files]="descriptionFiles()"
          [canSetAsAvatar]="true"
          [avatarFileId]="task().avatarId"
          class="flex-1 min-w-0"
        />
      }
    </div>
  </div>
</div>

@if (showAcknowledgeDescription()) {
  <proffeo-task-description-acknowledgement-checkbox
    [task]="task()"
    class="w-full"
  />
}
